'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _utils = require('helpers/utils');

var _auth = require('redux/modules/auth');

var authAction = _interopRequireWildcard(_auth);

var _cloud = require('redux/modules/cloud');

var cloudActions = _interopRequireWildcard(_cloud);

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _components = require('components');

var _cloud2 = require('selectors/cloud');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _projects = require('helpers/projects');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var boxcomImg = require('assets/boxcom-icon.png');

var service = 'boxcom';

var BoxcomPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    csrfState: state.cloud[service].csrfState,
    error: (0, _cloud2.getError)(state, service),
    files: (0, _cloud2.getFiles)(state, service),
    pathId: (0, _cloud2.getPathId)(state, service),
    pathCollection: state.cloud[service].pathCollection,
    processing: (0, _cloud2.getProcessing)(state, service),
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authAction, projectActions, cloudActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(BoxcomPopup, _Component);

  function BoxcomPopup() {
    var _ref;

    (0, _classCallCheck3.default)(this, BoxcomPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomPopup.__proto__ || (0, _getPrototypeOf2.default)(BoxcomPopup)).call.apply(_ref, [this].concat(args)));

    _this.onAuth = function (e) {
      var _this$props = _this.props,
          csrfState = _this$props.csrfState,
          boxcomGetToken = _this$props.boxcomGetToken,
          updateBoxToken = _this$props.updateBoxToken;
      var _e$detail = e.detail,
          state = _e$detail.state,
          code = _e$detail.code;


      window.removeEventListener('onBoxcomAuth', _this.onAuth);
      setTimeout(function () {
        _this.authWindow.close();
        _this.authWindow = null;
      }, 1000);

      if (state === csrfState && code) {
        boxcomGetToken(code).promise.then(function (resp) {
          updateBoxToken(service, resp.data);
          _this.openCloudBrowser();
        });
      }
    };

    _this.getFileFromResp = function (item) {
      return {
        service: service,
        uniqId: item.__id + '-' + Date.now(),
        url: '',
        name: item.name,
        size: item.size
      };
    };

    _this.state = { files: [] };
    return _this;
  }

  (0, _createClass3.default)(BoxcomPopup, [{
    key: 'onSelect',
    value: function onSelect(item, breadcrumb) {
      if (item && item.__type === 'folder') {
        this.loadPath(item.id, this.getPathCollection(item));
      } else if (typeof breadcrumb !== 'undefined') {
        this.loadPath(breadcrumb.id, breadcrumb.pathCollection);
      }
    }
  }, {
    key: 'onDownload',
    value: function onDownload(_ref2) {
      var fileItem = _ref2.fileItem,
          resp = _ref2.resp,
          err = _ref2.err;
      var _props = this.props,
          setCloudFileSuccessStatus = _props.setCloudFileSuccessStatus,
          setCloudFileFailedStatus = _props.setCloudFileFailedStatus,
          setCloudFileMetadata = _props.setCloudFileMetadata,
          onUpload = _props.onUpload,
          projectId = _props.projectId,
          addFailedMedia = _props.addFailedMedia;

      var res = (0, _extends3.default)({}, fileItem, resp.data);

      setCloudFileMetadata({ uniqId: fileItem.uniqId, metadata: resp.data });
      if (err) {
        addFailedMedia((0, _extends3.default)({}, fileItem), projectId);
        setCloudFileFailedStatus(fileItem.uniqId);
      } else {
        onUpload(res);
        setCloudFileSuccessStatus(fileItem.uniqId);
      }

      return res;
    }
  }, {
    key: 'onResult',
    value: function onResult(items) {
      var _this2 = this;

      var _props2 = this.props,
          boxcomDownloadFile = _props2.boxcomDownloadFile,
          setProcessing = _props2.setProcessing,
          submitCloudFile = _props2.submitCloudFile,
          projectId = _props2.projectId,
          projectType = _props2.projectType;


      var itemsArr = (0, _values2.default)(items);
      if (!itemsArr.length) {
        return false;
      }

      setProcessing(service, true);
      this.closeCloudBrowser();
      var promises = [];

      itemsArr.map(function (item) {
        var fileItem = (0, _extends3.default)({}, _this2.getFileFromResp(item));
        var promise = boxcomDownloadFile({ fileId: item.__id, fileName: item.__name, projectId: projectId, projectType: projectType }).promise.then(function (resp) {
          return _this2.onDownload({ fileItem: fileItem, resp: resp });
        }).catch(function (err) {
          return _this2.onDownload({ fileItem: fileItem, err: err });
        });
        promises.push(promise);
        submitCloudFile(fileItem);
      });

      _promise2.default.all(promises).then(function () {
        return setProcessing(service, false);
      }).catch(function () {
        return setProcessing(service, false);
      });
    }
  }, {
    key: 'getRootPathCollection',
    value: function getRootPathCollection() {
      var t = this.props.t;

      return [{ id: '0', name: t('Box files') }];
    }
  }, {
    key: 'getPathCollection',
    value: function getPathCollection(item) {
      var _this3 = this;

      var res = [];
      item.path_collection.entries.map(function (entry, index) {
        if (!index) {
          res.push.apply(res, (0, _toConsumableArray3.default)(_this3.getRootPathCollection()));
        } else {
          res.push({ id: entry.id, name: entry.name });
        }
      });
      res.push({ id: item.id, name: item.name });
      return res;
    }
  }, {
    key: 'loadPath',
    value: function loadPath(pathId) {
      var _this4 = this;

      var pathCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getRootPathCollection();
      var _props3 = this.props,
          setFiles = _props3.setFiles,
          setError = _props3.setError,
          setPath = _props3.setPath,
          setPathCollection = _props3.setPathCollection,
          boxcomGetFolders = _props3.boxcomGetFolders;

      var isSamePath = function isSamePath() {
        return _this4.props.pathId === pathId;
      };
      setPath(service, pathId);
      setPathCollection(service, pathCollection);

      boxcomGetFolders(pathId).promise.then(function (resp) {
        return isSamePath() ? setFiles({ service: service, pathId: pathId, files: resp.data.entries }) : false;
      }).catch(function (err) {
        return isSamePath() ? setError(service, err.msg || err.error) : false;
      });
    }
  }, {
    key: 'openCloudBrowser',
    value: function openCloudBrowser() {
      this.modal.open();
      this.loadPath('0');
    }
  }, {
    key: 'closeCloudBrowser',
    value: function closeCloudBrowser() {
      this.modal.close();
    }
  }, {
    key: 'openBoxcom',
    value: function openBoxcom(forceAuth) {
      var _props4 = this.props,
          user = _props4.user,
          setCSRFState = _props4.setCSRFState;

      var state = Date.now().toString();
      setCSRFState(service, state);

      if (!user.boxcomToken || forceAuth) {
        var redirectUri = encodeURIComponent(document.location.origin + '/processing/cloudauth/boxcom');
        var baseUrl = 'https://account.box.com/api/oauth2/authorize';
        var authUrl = baseUrl + '?response_type=code&client_id=' + _config2.default.app.boxcom.clientId + '&redirect_uri=' + redirectUri + '&state=' + state;
        this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 400, 500);
        window.addEventListener('onBoxcomAuth', this.onAuth);
      } else {
        this.openCloudBrowser();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props5 = this.props,
          t = _props5.t,
          files = _props5.files,
          error = _props5.error,
          pathId = _props5.pathId,
          pathCollection = _props5.pathCollection,
          processing = _props5.processing,
          fileTypes = _props5.fileTypes,
          disabled = _props5.disabled;


      var modalProps = {
        backdrop: true,
        closeByEsc: false,
        title: t('Add Box files'),
        bsSize: 'lg',
        withoutPadding: true,
        simpleHeader: true
      };

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-clear', onClick: function onClick() {
              return _this5.openBoxcom();
            }, disabled: disabled },
          _react2.default.createElement(
            _components.Tooltip,
            { placement: 'bottom', title: 'Box.com' },
            _react2.default.createElement('img', { src: boxcomImg, alt: '' })
          )
        ),
        _react2.default.createElement(
          _components.Modal,
          (0, _extends3.default)({ ref: function ref(el) {
              return _this5.modal = el;
            } }, modalProps),
          _react2.default.createElement(_components.CloudBrowser, {
            items: files,
            fileTypes: fileTypes,
            service: service,
            pathId: pathId,
            pathCollection: pathCollection,
            error: error,
            processing: processing,
            onCancel: this.closeCloudBrowser,
            onSelect: this.onSelect,
            onResult: this.onResult,
            onError: function onError() {
              return _this5.openBoxcom(true);
            }
          })
        )
      );
    }
  }]);
  return BoxcomPopup;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addFailedMedia: _propTypes2.default.func,
  boxcomDownloadFile: _propTypes2.default.func,
  boxcomGetFolders: _propTypes2.default.func,
  boxcomGetToken: _propTypes2.default.func,
  csrfState: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  files: _propTypes2.default.array,
  fileTypes: _propTypes2.default.array,
  onUpload: _propTypes2.default.func,
  pathCollection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    path: _propTypes2.default.string
  })),
  pathId: _propTypes2.default.string,
  processing: _propTypes2.default.bool,
  projectId: _propTypes2.default.number,
  projectType: _propTypes2.default.string,
  setCloudFileFailedStatus: _propTypes2.default.func,
  setCloudFileMetadata: _propTypes2.default.func,
  setCloudFileSuccessStatus: _propTypes2.default.func,
  setCSRFState: _propTypes2.default.func,
  setError: _propTypes2.default.func,
  setFiles: _propTypes2.default.func,
  setPath: _propTypes2.default.func,
  setPathCollection: _propTypes2.default.func,
  setProcessing: _propTypes2.default.func,
  submitCloudFile: _propTypes2.default.func,
  t: _propTypes2.default.func,
  updateBoxToken: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _class3.defaultProps = {
  onUpload: function onUpload() {},
  projectType: _projects.projectTypes.audio
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onResult', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onResult'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeCloudBrowser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeCloudBrowser'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = BoxcomPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Boxcom/BoxcomPopup.js
// module id = 1961
// module chunks = 1